import React from 'react';
import { StyledSvgIcon } from '../icon.styles';
import { customIconsPropTypes } from './customicons.propTypes';

const TowIcon = ({ fontSize, color, sx, title }) => (
  <StyledSvgIcon
    fontSize={fontSize}
    color={color}
    titleAccess={title}
    data-testid={title}
    aria-label={title}
    sx={sx}
  >
    <svg viewBox="0 0 141 103" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M89.7273 38.625H124.272L102.93 12.875H89.7273V38.625ZM105.75 93.3438C108.25 93.3438 110.493 92.5069 112.415 90.5756C114.338 88.6444 115.364 86.3913 115.364 83.6875C115.364 81.1769 114.338 78.9238 112.415 76.9925C110.493 75.0612 108.25 74.0312 105.75 74.0312C103.058 74.0312 100.815 75.0612 98.8923 76.9925C96.9696 78.9238 96.1364 81.1769 96.1364 83.6875C96.1364 86.3913 96.9696 88.6444 98.8923 90.5756C100.815 92.5069 103.058 93.3438 105.75 93.3438ZM32.0455 93.3438C34.8655 93.3438 37.1727 92.5069 38.9673 90.5756C40.7618 88.6444 41.6591 86.3913 41.6591 83.6875C41.6591 81.1769 40.7618 78.9238 38.9673 76.9925C37.1727 75.0612 34.8655 74.0312 32.0455 74.0312C29.2255 74.0312 26.9182 75.0612 25.1236 76.9925C23.3291 78.9238 22.4318 81.1769 22.4318 83.6875C22.4318 86.3913 23.3291 88.6444 25.1236 90.5756C26.9182 92.5069 29.2255 93.3438 32.0455 93.3438ZM108.955 0L141 38.625V83.6875H124.977C124.977 89.0306 122.99 93.5369 119.145 97.3994C115.364 101.197 110.877 103 105.75 103C100.43 103 95.9441 101.197 92.1627 97.3994C88.3173 93.5369 86.5227 89.0306 86.5227 83.6875H51.2727C51.2727 89.0306 49.35 93.5369 45.5686 97.3994C41.6591 101.197 37.2368 103 32.0455 103C26.8541 103 22.4318 101.197 18.5223 97.3994C14.7409 93.5369 12.8182 89.0306 12.8182 83.6875H0V57.9375H52.4905L12.8182 26.4581V45.0625H0V6.4375H6.40909L76.9091 45.4488V0H108.955Z"
        fill="currentColor"
      />
    </svg>
  </StyledSvgIcon>
);
export default TowIcon;

TowIcon.propTypes = customIconsPropTypes;
